import React, { useEffect, useState } from "react";
import {
  FaBell,
  FaCar,
  FaFire,
  FaHardHat,
  FaHeadSideMask,
  FaPauseCircle,
  FaRegCalendarCheck,
  FaUserFriends,
  FaVideo,
} from "react-icons/fa";
import { IoNotificationsOutline } from "react-icons/io5";
import "./style.css";
import AlertsGraph from "./Grapgh";
import { EventListApi } from "../../api/api";
import { fontSize } from "@mui/system";
import { useNavigate } from "react-router-dom";
import { PulseLoader } from "react-spinners";

export default function Report() {
  const [selectedDate, setSelectedDate] = useState("2025-07-11");
  const [events, setevents] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState("");
  const [activeFilter, setActiveFilter] = useState("daily");
  const [endDate, setEndDate] = useState("");
  const [customStart, setCustomStart] = useState("");
  const [customEnd, setCustomEnd] = useState("");
  const [showCustomFilter, setShowCustomFilter] = useState(false);

  const fetchEvents = async () => {
    try {
      setLoading(true); 
      const data = await EventListApi(startDate, endDate);
      if (data) {
        setevents(data?.data?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchEvents();
    updateDateRange("daily");
  }, []);

  useEffect(() => {
    if (startDate && endDate) {
      fetchEvents();
    }
  }, [startDate, endDate]);

  const updateDateRange = (filter) => {
    const today = new Date();
    let start, end;

    switch (filter) {
      case "daily":
        start = end = today;
        break;
      case "weekly":
        start = new Date(today);
        start.setDate(today.getDate() - 7);
        end = today;
        break;
      case "monthly":
        start = new Date(today);
        start.setMonth(today.getMonth() - 1);
        end = today;
        break;
      default:
        start = end = today;
    }

    const format = (date) => date.toISOString().split("T")[0];
    setStartDate(format(start));
    setEndDate(format(end));
  };

  return (
    <div className="dashboard">
      {/* Header */}
      {loading && (
        <div className="loader-overlay">
          <div className="loader">
            <PulseLoader color="#fff" />
          </div>
        </div>
      )}
      <h2 className="dashboard-title">Reports</h2>

      {/* Stats Section */}
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-label d-flex align-items-center gap-2">
            <FaRegCalendarCheck size={18} className="stat-icon" />
            Event Created
          </div>
          <h2 className="stat-value">
            {events?.stats?.total_events}
            Events
          </h2>
        </div>

        <div className="stat-card">
          <div className="stat-label d-flex align-items-center gap-2">
            <FaBell size={18} className="stat-icon" />
            Alerts
          </div>
          <h2 className="stat-value">
            {events?.stats?.logs_count?.notification_logs} Alerts
          </h2>
        </div>

        <div className="stat-card">
          <div className="stat-label d-flex align-items-center gap-2">
            <FaVideo size={18} className="stat-icon" />
            Number of Cameras
          </div>
          <h2 className="stat-value">
            {events?.stats?.total_cameras}
            Cameras
          </h2>
        </div>

        <div className="stat-card">
          <div className="stat-label d-flex align-items-center gap-2">
            <FaPauseCircle size={18} className="stat-icon" />
            Idle Cameras
          </div>
          <h2 className="stat-value">02 Cameras</h2>
        </div>
      </div>

      {/* Alerts & Notifications Topbar */}
      <div className="alerts-topbar">
        <div className="heading-left">
          <IoNotificationsOutline size={20} className="notif-icon" />
          <h3>Alerts and Notifications</h3>
        </div>
      </div>

      {/* Tabs + Date Selector in One Line */}
      <div className="filters-bar">
        <div className="date-selector">
          <input
            type="date"
            className="date-picker"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          />
        </div>

        <div className="filter-toggle-wrapper d-flex justify-content-end mb-3 flex-wrap">
          <div className="filter-toggle-group">
            <button
              className={`filter-toggle-btn ${
                activeFilter === "daily" ? "active" : ""
              }`}
              onClick={() => {
                setActiveFilter("daily");
                updateDateRange("daily");
              }}
            >
              Daily
            </button>
            <button
              className={`filter-toggle-btn ${
                activeFilter === "weekly" ? "active" : ""
              }`}
              onClick={() => {
                setActiveFilter("weekly");
                updateDateRange("weekly");
              }}
            >
              Weekly
            </button>
            <button
              className={`filter-toggle-btn ${
                activeFilter === "monthly" ? "active" : ""
              }`}
              onClick={() => {
                setActiveFilter("monthly");
                updateDateRange("monthly");
              }}
            >
              Monthly
            </button>
            <button
              className={`filter-toggle-btn ${
                activeFilter === "custom" ? "active" : ""
              }`}
              onClick={() => {
                setActiveFilter("custom");
                setShowCustomFilter(true);
              }}
            >
              Custom
            </button>
          </div>
        </div>

        {/* Custom filter shown BELOW */}
        {activeFilter === "custom" && showCustomFilter && (
          <div className="custom-date-wrapper d-flex gap-3 align-items-end mb-3 flex-wrap p-3 bg-white rounded shadow-sm border">
            <div>
              <label className="form-label">Start Date</label>
              <input
                type="date"
                className="form-control"
                value={customStart}
                onChange={(e) => setCustomStart(e.target.value)}
              />
            </div>
            <div>
              <label className="form-label">End Date</label>
              <input
                type="date"
                className="form-control"
                value={customEnd}
                onChange={(e) => setCustomEnd(e.target.value)}
              />
            </div>
            <div>
              <button
                className="btn btn-primary"
                onClick={() => {
                  setStartDate(customStart);
                  setEndDate(customEnd);
                  setShowCustomFilter(false);
                }}
                disabled={!customStart || !customEnd}
              >
                Apply
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Main Content */}
      <div className="main-section">
        {/* Alerts Graph */}
        <div className="alerts-card">
          <AlertsGraph data={events?.stats?.logs_count} />
        </div>

        {/* Notifications */}

        <div className="notifications-card">
          <div className="notif-header">
            <h3>Notifications</h3>
            <span>All</span>
          </div>

          <ul className="notif-list">
            {events?.notification_data?.length > 0 ? (
              events.notification_data.slice(0, 8).map((notif) => {
                // Determine color + icon consistently
                let colorClass = "gray";
                let icon;

                if (notif.event_type_name?.includes("fire")) {
                  colorClass = "red";
                  icon = (
                    <FaFire className={`notif-icon ${colorClass}`} size={25} />
                  );
                } else if (notif.event_type_name?.includes("number_plate")) {
                  colorClass = "blue";
                  icon = (
                    <FaCar className={`notif-icon ${colorClass}`} size={25} />
                  );
                } else if (notif.event_type_name?.includes("crowd")) {
                  colorClass = "yellow";
                  icon = (
                    <FaUserFriends
                      className={`notif-icon ${colorClass}`}
                      size={25}
                    />
                  );
                } else if (notif.event_type_name?.includes("hardhat")) {
                  colorClass = "yellow";
                  icon = (
                    <FaHardHat
                      className={`notif-icon ${colorClass}`}
                      size={25}
                    />
                  );
                } else if (notif.event_type_name?.includes("facemask")) {
                  colorClass = "blue";
                  icon = (
                    <FaHeadSideMask
                      className={`notif-icon ${colorClass}`}
                      size={25}
                    />
                  );
                } else {
                  icon = (
                    <FaBell className={`notif-icon ${colorClass}`} size={25} />
                  );
                }

                return (
                  <li key={notif._id} className={`notif-item ${colorClass}`}>
                    {icon}
                    <span style={{ fontSize: "15px" }}>
                      {notif.notification_message}
                    </span>
                  </li>
                );
              })
            ) : (
              <li className="notif-item gray">No notifications available</li>
            )}
          </ul>

          <button
            className="view-all-btn"
            onClick={() => navigate("/notifications")}
          >
            View All
          </button>
        </div>
      </div>
    </div>
  );
}
